import { PapiEditorText, PapiOriginalsQuestion } from '@wix/da-papi-types';

export enum ArtsAndCraftsDeviationFieldName {
  TITLE = 'title',
  DESCRIPTION = 'description',
  MATURE_CONTENT = 'matureContent',
  PRICE = 'price',
  TAGS = 'tags',
  CATEGORY = 'category',
  GALLERY = 'gallery',
  DISPLAY_RESOLUTION = 'displayResolution',
  ADD_WATERMARK = 'addWatermark',
  OPEN_FOR_ORDERS = 'openForOrders',
  SHIPPING_PROFILE = 'shippingProfile',
  QUESTIONS = 'questions',
}

export interface ArtsAndCraftsDeviationFormFields {
  [ArtsAndCraftsDeviationFieldName.TITLE]: string;
  [ArtsAndCraftsDeviationFieldName.DESCRIPTION]: () => string;
  [ArtsAndCraftsDeviationFieldName.MATURE_CONTENT]: boolean;
  [ArtsAndCraftsDeviationFieldName.PRICE]: number;
  [ArtsAndCraftsDeviationFieldName.TAGS]: string[];
  [ArtsAndCraftsDeviationFieldName.CATEGORY]: string;
  [ArtsAndCraftsDeviationFieldName.GALLERY]: string;
  [ArtsAndCraftsDeviationFieldName.DISPLAY_RESOLUTION]: number;
  [ArtsAndCraftsDeviationFieldName.ADD_WATERMARK]: boolean;
  [ArtsAndCraftsDeviationFieldName.OPEN_FOR_ORDERS]: boolean;
  [ArtsAndCraftsDeviationFieldName.SHIPPING_PROFILE]: number;
  [ArtsAndCraftsDeviationFieldName.QUESTIONS]: AnCQuestionWithEditorState[];
}

export enum AnCQuestionFieldName {
  QUESTION_BODY = 'questionBody',
  QUESTION_TYPE = 'questionType',
  ANSWER_CHOICES = 'answerChoices',
  IS_REQUIRED = 'isRequired',
}

export interface AnCQuestionFormFields {
  [AnCQuestionFieldName.QUESTION_BODY]: () => string;
  [AnCQuestionFieldName.QUESTION_TYPE]: AnCQuestionType;
  [AnCQuestionFieldName.IS_REQUIRED]: boolean;
  [AnCQuestionFieldName.ANSWER_CHOICES]?: AnCAnswerChoice[];
}

export interface AnCQuestionWithEditorState extends Omit<
  PapiOriginalsQuestion,
  'questionId' | 'position' | 'question'
> {
  questionId?: number;
  question?: PapiEditorText;
  questionEditor?: () => string;
}

export interface AnCUnsavedQuestion extends Omit<PapiOriginalsQuestion, 'questionId' | 'position'> {
  questionId?: number;
  position?: number;
}

export type AnCQuestionType = PapiOriginalsQuestion['type'];

export type AnCAnswerChoice = NonNullable<PapiOriginalsQuestion['answers']>[number];
